import { NotFoundPage } from '~/components';
import {
  AccountSettingAdmin,
  AlertAdmin,
  AgentAdmin,
  Calendar,
  Client,
  Component,
  CRMAdmin,
  DashboardAdmin,
  MapAdmin,
  JourneyPlaybackAdmin,
  EstimateAdmin,
  Event,
  FacilityAdmin,
  HomeUser,
  Inventory,
  InvoiceAdmin,
  Operation,
  ProfileAdmin,
  ProjectAdmin,
  ReportAdmin,
  ReportViolationsAdmin,
  ReportJourneyAdmin,
  ScheduleAdmin,
  SignUpAdmin,
  TimeClockAdmin,
  Timesheet,
  UserAdmin,
  ChangePassword,
  PersonAdmin,
  LocationAdmin,
  PersonDetailAdmin,
  PersonHistoryAdmin,
  PersonHealthAdmin,
  PersonLocationHistoryAdmin,
  ActionLogAdmin,
  DeviceAdmin,
} from '~/pages';

import ForgotPassword from '~/pages/admin/auth/forgot-password/ForgotPassword';
import OtpConfirmation from '~/pages/admin/auth/otp-confirmation/OtpConfirmation';
import ResetPassword from '~/pages/admin/auth/reset-password/ResetPassword';
import { IRouteModel } from '../interface/common';
import LoginAdmin from '~/pages/admin/auth/login-admin/LoginAdmin';
import Equipment from '~/pages/admin/equipment/Equipment';
import Technician from '~/pages/admin/technicians/Technician';
import Distributor from '~/pages/admin/distributor/Distributor';

// Router && Path
export const adminRoute = {
  base: '/admin',
  login: '/login',
  forgotPassword: '/forgot-password',
  optConfirmation: '/otp-confirmation',
  resetPassword: '/reset-password',
  signUp: '/sign-up',
  dashboard: '/dashboard',
  map: '/map',
  mapback: '/mapback',
  mapbackJourney: '/mapback/journey/:personId',
  schedule: '/schedule',
  projects: '/projects',
  facilities: '/facilities',
  users: '/users',
  agents: '/agents',
  cRM: '/crm',
  timeClocks: '/time-clocks',
  invoices: '/invoices',
  estimates: '/estimates',
  reports: '/reports',
  reportsViolations: '/report-violation',
  reportsJourney: '/report-journey',
  profile: '/profile',
  changePassword: '/change-password',
  accountSetting: '/account-setting',
  components: '/components',
  calendar: '/calendar',
  events: '/events',
  clients: '/clients',
  operation: '/operation',
  inventories: '/inventories',
  timesheets: '/timesheets',
  equipment: '/equipment',
  devices: '/devices',
  alerts: '/alerts',
  technicians: '/technicians',
  distributors: '/distributors',
  location: '/locations',
  person: '/persons',
  personDetail: '/persons/:id',
  personHistory: '/persons/:id/history',
  personHealth: '/persons/:id/health',
  personLocationHistory: '/persons/:id/location-history',
  personDevices: '/persons/:id/devices',
  actionLog: '/action-logs',
};

export const userRoute = {
  base: '/',
  home: '/home',
  component: '/component',
};

export const adminRouteAbsolute = {
  projects: `${adminRoute.base}${adminRoute.projects}`,
  schedule: `${adminRoute.base}${adminRoute.schedule}`,
  dashboard: `${adminRoute.base}${adminRoute.dashboard}`,
  map: `${adminRoute.base}${adminRoute.map}`,
  devices: `${adminRoute.base}${adminRoute.devices}`,
  alerts: `${adminRoute.base}${adminRoute.alerts}`,
  mapback: `${adminRoute.base}${adminRoute.mapback}`,
  mapbackJourneyBase: `${adminRoute.base}${adminRoute.mapbackJourney.replace('/:personId', '')}`,
  mapbackJourney: `${adminRoute.base}${adminRoute.mapbackJourney}`,
  login: `${adminRoute.base}${adminRoute.login}`,
  signUp: `${adminRoute.base}${adminRoute.signUp}`,
  profile: `${adminRoute.base}${adminRoute.profile}`,
  changePassword: `${adminRoute.base}${adminRoute.changePassword}`,
  accountSetting: `${adminRoute.base}${adminRoute.accountSetting}`,
  reports: `${adminRoute.base}${adminRoute.reports}`,
  reportsViolations: `${adminRoute.base}${adminRoute.reportsViolations}`,
  reportsJourney: `${adminRoute.base}${adminRoute.reportsJourney}`,
};

//#region Admin Routes
export const publicAdminRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.login}`,
    component: LoginAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.forgotPassword}`,
    component: ForgotPassword,
  },
  {
    path: `${adminRoute.base}${adminRoute.optConfirmation}`,
    component: OtpConfirmation,
  },
  {
    path: `${adminRoute.base}${adminRoute.resetPassword}`,
    component: ResetPassword,
  },
  {
    path: `${adminRoute.base}${adminRoute.signUp}`,
    component: SignUpAdmin,
  },
];

export const privateAdminRoutes: IRouteModel[] = [
  {
    path: `${adminRoute.base}${adminRoute.dashboard}`,
    component: DashboardAdmin,
    name: 'Dashboard',
  },
  {
    path: `${adminRoute.base}${adminRoute.map}`,
    component: MapAdmin,
    name: 'Map',
  },
  {
    path: `${adminRoute.base}${adminRoute.mapback}`,
    component: JourneyPlaybackAdmin,
    name: 'MapPlayback',
  },
  {
    path: adminRouteAbsolute.mapbackJourney,
    component: JourneyPlaybackAdmin,
    name: 'JourneyPlaybackByPerson',
  },
  {
    path: `${adminRoute.base}${adminRoute.schedule}`,
    component: ScheduleAdmin,
    name: 'Schedule',
  },
  {
    path: `${adminRoute.base}${adminRoute.projects}`,
    component: ProjectAdmin,
    name: 'Project',
  },
  {
    path: `${adminRoute.base}${adminRoute.facilities}`,
    component: FacilityAdmin,
    name: 'facilities',
  },
  {
    path: `${adminRoute.base}${adminRoute.users}`,
    component: UserAdmin,
    name: 'User',
  },
  {
    path: `${adminRoute.base}${adminRoute.agents}`,
    component: AgentAdmin,
    name: 'Agent',
  },
  {
    path: `${adminRoute.base}${adminRoute.cRM}`,
    component: CRMAdmin,
    name: 'CRM',
  },
  {
    path: `${adminRoute.base}${adminRoute.timeClocks}`,
    component: TimeClockAdmin,
    name: 'TimeClock',
  },
  {
    path: `${adminRoute.base}${adminRoute.invoices}`,
    component: InvoiceAdmin,
    name: 'Invoice',
  },
  {
    path: `${adminRoute.base}${adminRoute.actionLog}`,
    component: ActionLogAdmin,
    name: 'ActionLog',
  },
  {
    path: `${adminRoute.base}${adminRoute.estimates}`,
    component: EstimateAdmin,
    name: 'Estimate',
  },
  {
    path: `${adminRoute.base}${adminRoute.reportsViolations}`,
    component: ReportViolationsAdmin,
    name: 'ReportViolations',
  },
  {
    path: `${adminRoute.base}${adminRoute.reportsJourney}`,
    component: ReportJourneyAdmin,
    name: 'ReportJourney',
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}`,
    component: ReportAdmin,
    name: 'Report',
  },
  {
    path: `${adminRoute.base}${adminRoute.profile}`,
    component: ProfileAdmin,
    name: 'Profile',
  },
  {
    path: `${adminRoute.base}${adminRoute.changePassword}`,
    component: ChangePassword,
    name: 'Change Pasword',
  },
  {
    path: `${adminRoute.base}${adminRoute.accountSetting}`,
    component: AccountSettingAdmin,
    name: 'AccountSetting',
  },
  {
    path: `${adminRoute.base}${adminRoute.components}`,
    component: Component,
    name: 'Components',
  },
  {
    path: `${adminRoute.base}${adminRoute.calendar}`,
    component: Calendar,
    name: 'Calendar',
  },
  {
    path: `${adminRoute.base}${adminRoute.events}`,
    component: Event,
    name: 'Event',
  },
  {
    path: `${adminRoute.base}${adminRoute.clients}`,
    component: Client,
    name: 'Client',
  },
  {
    path: `${adminRoute.base}${adminRoute.operation}`,
    component: Operation,
    name: 'Operation',
  },
  {
    path: `${adminRoute.base}${adminRoute.inventories}`,
    component: Inventory,
    name: 'Inventory',
  },
  {
    path: `${adminRoute.base}${adminRoute.timesheets}`,
    component: Timesheet,
    name: 'Timesheet',
  },
  {
    path: `${adminRoute.base}${adminRoute.equipment}`,
    component: Equipment,
    name: 'Equipment',
  },
  {
    path: `${adminRoute.base}${adminRoute.devices}`,
    component: DeviceAdmin,
    name: 'Device',
  },
  {
    path: `${adminRoute.base}${adminRoute.alerts}`,
    component: AlertAdmin,
    name: 'Alert',
  },
  {
    path: `${adminRoute.base}${adminRoute.technicians}`,
    component: Technician,
    name: 'Technician',
  },
  {
    path: `${adminRoute.base}${adminRoute.distributors}`,
    component: Distributor,
    name: 'Distributor',
  },
  {
    path: `${adminRoute.base}${adminRoute.location}`,
    component: LocationAdmin,
    name: 'Location',
  },
  {
    path: `${adminRoute.base}${adminRoute.person}`,
    component: PersonAdmin,
    name: 'Person',
  },
  {
    path: `${adminRoute.base}${adminRoute.personDetail}`,
    component: PersonDetailAdmin,
    name: 'PersonDetailAdmin',
  },
  {
    path: `${adminRoute.base}${adminRoute.personHistory}`,
    component: PersonHistoryAdmin,
    name: 'PersonHistoryAdmin',
  },
  {
    path: `${adminRoute.base}${adminRoute.personHistory}`,
    component: PersonHistoryAdmin,
    name: 'PersonHistoryAdmin',
  },
  {
    path: `${adminRoute.base}${adminRoute.personHealth}`,
    component: PersonHealthAdmin,
    name: 'PersonHealthAdmin',
  },
  {
    path: `${adminRoute.base}${adminRoute.personLocationHistory}`,
    component: PersonLocationHistoryAdmin,
    name: 'PersonLocationHistoryAdmin',
  },
];
//#endregion Admin Routes

//#region Patient Routes
export const publicUserRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
];

export const privateUserRoutes: IRouteModel[] = [
  {
    path: userRoute.home,
    component: HomeUser,
  },
];
//#endregion Patient Routes

export const publicRoutes = [...publicAdminRoutes, ...publicUserRoutes];

export const privateRoutes = [];
